export default __webpack_public_path__ + "dist/media/logo-ec--en.71eb7605.svg";